import type { SessionRecordingOptions } from 'posthog-js'
import { routes } from '~/config/routes'

export const stripUrlQueryAndHash = (value: string) => {
  try {
    const url = new URL(value)

    return `${url.origin}${url.pathname}`
  } catch {
    return value.split(/[?#]/, 1)[0]
  }
}

const SELF_SERVICE_SIGN_UP_PATHS = [
  routes.signUp,
  routes.selfServiceSignUp.verifyEmail,
  routes.selfServiceSignUp.nonprofit,
  routes.selfServiceSignUp.stripe,
  stripUrlQueryAndHash(routes.selfServiceSignUp.stripeReturn('')),
  stripUrlQueryAndHash(routes.selfServiceSignUp.stripeRefresh(''))
]

export const POSTHOG_SESSION_RECORDING_OPTIONS = {
  maskAllInputs: true,
  maskCapturedNetworkRequestFn: request => ({
    ...request,
    name: stripUrlQueryAndHash(request.name)
  })
} satisfies SessionRecordingOptions

const isPathOrChild = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`)

export const isPosthogTrackedPath = (pathname: string) =>
  isPathOrChild(pathname, '/dashboard') || SELF_SERVICE_SIGN_UP_PATHS.includes(pathname)

type SessionRecordingClient = {
  startSessionRecording: () => void
  stopSessionRecording: () => void
}

export const updatePosthogSessionRecording = (
  client: SessionRecordingClient,
  pathname: string,
  wasTracked: boolean
) => {
  const isTracked = isPosthogTrackedPath(pathname)

  if (isTracked && !wasTracked) {
    client.startSessionRecording()
  } else if (!isTracked && wasTracked) {
    client.stopSessionRecording()
  }

  return isTracked
}
